import numeral from "numeral";
import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

// redux
import { setSearchApplicationStatus } from "../../../../../redux/slices/micro-project/microProjectSlices";

const TotalCostApproved = () => {
  const dispatch = useDispatch();

  const { data } = useSelector((state) => ({
    data: state.microProjectReducer.applicationStatistics?.total_approved_cost,
  }));

  return (
    <React.Fragment>
      <Card className='w-100 flex-fill'>
        <Card.Header className='pb-0'>
          <h5 className='text-uppercase'>Jumlah Kos Diluluskan</h5>
        </Card.Header>
        <Card.Body className='pt-0 d-flex justify-content-center align-items-center'>
          <div style={{ fontSize: 26, fontWeight: 700 }}>
            {`RM ${numeral(data).format("0,0.00")}`}
          </div>
        </Card.Body>
      </Card>
    </React.Fragment>
  );
};

export default TotalCostApproved;
